export default __webpack_public_path__ + "static/media/thrivingPetsLogo-white.0e3cc16c.svg";